// removed by extract-text-webpack-plugin
module.exports = {"bpTablet":"1635px","bpNoResize":"960px","bpPhone":"887px","bpPhoneLandscape":"475px"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/header/HeaderEvent.scss
// module id = 317
// module chunks = 0